import { Spacer, Text } from '@sendoutcards/quantum-design-ui'
import React, { FC } from 'react'

import { ExpenseReload } from 'src/graphql'
import { FlexColumn, FlexRow } from 'src/styled'

import DollaPicka from '../DollaPicka'
import styles from './styles'

interface ExpenseReloadFormProps {
  expenseReload: ExpenseReload
  onChange: (name: 'purchaseAmount' | 'threshold', value: number) => void
}

const ExpenseReloadForm: FC<ExpenseReloadFormProps> = props => {
  const {
    expenseReload: { purchaseAmount, threshold },
    onChange,
  } = props
  return (
    <FlexRow css={styles.expenseReload}>
      <div css={styles.column}>
        <Text type="body" color="primaryHeading">
          Expense amount
        </Text>
        <Spacer space="x1" />
        <Text type="footnote">
          select the amount you would like in your expense bucket
        </Text>
        <DollaPicka
          css={styles.picka}
          amount={purchaseAmount}
          min={10}
          max={50}
          step={5}
          onChange={amount => onChange('purchaseAmount', amount)}
        />
      </div>
      <FlexColumn css={styles.threshold}>
        <Text type="body" color="primaryHeading">
          Threshold
        </Text>
        <Spacer space="x1" />
        <Text type="footnote">Reload when my bucket balance reaches:</Text>
        <DollaPicka
          css={styles.picka}
          amount={threshold}
          min={1}
          max={purchaseAmount * 100 - 100}
          step={50}
          shouldShowDecimal={true}
          onChange={amount => onChange('threshold', amount)}
        />
      </FlexColumn>
    </FlexRow>
  )
}

export default ExpenseReloadForm
